module.exports = __webpack_public_path__ + "img/img_09.aff79cfd.jpg";